<div class="user-avatar">{{ initials() }}</div>
<div class="user-info">
  <div class="user-name">{{ name() }}</div>
  @if (role()) {
    <div class="user-role">{{ role() }}</div>
  }
</div>
<span class="user-action"><ng-content select="[action]" /></span>
